<template>
  <div>
    <b-card header-class="border-0">
      <b-row>
        <b-col>
          <base-input
            label="Membership ID"
            v-debounce:500ms="setMembershipId"
            v-model="id"
          >
          </base-input>
        </b-col>
        <b-col>
          <base-input label="Patient">
            <customerSelect v-on:nameSelected="nameSelected"></customerSelect>
            <small>Search by first, last name or e-mail</small>
          </base-input>
        </b-col>
        <b-col>
          <label class="form-control-label">Start Date</label>
          <b-form-datepicker
            id="startDate"
            class="col-sm-12"
            v-model="form.startDate"
            locale="en"
          ></b-form-datepicker>
        </b-col>
        <b-col>
          <label class="form-control-label">Start End Date</label>
          <b-form-datepicker
            id="endDate"
            class="col-sm-12"
            v-model="form.endDate"
            locale="en"
          ></b-form-datepicker>
        </b-col>
        <b-col class="mt-4">
          <b-form-checkbox-group
            :options="statusOptions"
            v-model="form.status"
          />
          <br />
          <b-form-checkbox
            v-model="form.isPastDue"
            size="sm"
            switch
            name="check-button"
          >
            Past Due Memberships
          </b-form-checkbox>
        </b-col>
      </b-row>
    </b-card>

    <b-card body-class="p-0" header-class="border-0">
      <search-results
        :query="form"
        ref="searchResults"
        @paymentPlanSelected="paymentPlanSelected"
      />
    </b-card>
  </div>
</template>
<script>
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import SearchResults from "@/views/Components/CustomerMembershipBilling/SearchResults";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

export default {
  name: "light-table",
  title: "Memberships",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    flatPicker,
    "search-results": SearchResults,
  },
  props: {
    itemLimit: {
      type: Number,
      default: 9,
    },
  },
  data() {
    return {
      statusOptions: [
        {
          text: "Active",
          value: "ACTIVE",
        },
        {
          text: "Awaiting Completion",
          value: "AWAITINGPATIENT",
        },
        {
          text: "Canceled",
          value: "INACTIVE",
        },
      ],
      id: null,
      form: {
        id: null,
        startDate: null,
        endDate: null,
        customerId: null,
        active: true,
        isPastDue: false,
        status: ["ACTIVE", "AWAITINGPATIENT"],
      },
    };
  },
  mounted() {
    var self = this;

    if (this.$route.query.isPastDue == "true") this.form.isPastDue = true;
  },
  methods: {
    setMembershipId() {
      this.form.id = this.id;
    },
    nameSelected(customer) {
      this.form.customerId = customer.id;
    },
  },
};
</script>
